import { Injectable, TemplateRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  public openDialog<T, D = any, R = any>(
    template: ComponentType<T> | TemplateRef<T>,
    config: MatDialogConfig<D>
  ): MatDialogRef<T, R> {
    return this.dialog.open(template, config);
  }

  public closeAll(): void {
    this.dialog.closeAll();
  }

  public createDefaultDialogConfig(data: any): MatDialogConfig {
    return this.createDialogConfig(data, '600px', '90%', '90%');
  }

  public createSmallDialogConfig(data: any): MatDialogConfig {
    return this.createDialogConfig(data, '350px', '90%', '90%');
  }

  public createLargeDialogConfig(data: any): MatDialogConfig {
    return this.createDialogConfig(data, '1000px', '90%', '90%');
  }

  public createFullsizeDialogConfig(data: any): MatDialogConfig {
    const config = this.createDialogConfig(data, '100%', '100%', '100%');
    config.height = '100%';
    config.panelClass = 'full-size-dialog-container';

    return config;
  }

  public makeTransparent(config: MatDialogConfig): MatDialogConfig {
    config.panelClass = 'transparent-dialog-container';
    return config;
  }

  public makeUnableToClose(config: MatDialogConfig): MatDialogConfig {
    config.disableClose = true;
    return config;
  }

  private createDialogConfig(
    data: any,
    width: string,
    maxWidth: string,
    maxHeight: string
  ): MatDialogConfig {
    const config = new MatDialogConfig();

    config.data = data;

    config.disableClose = false;
    config.autoFocus = false;
    config.restoreFocus = true;
    config.width = width;
    config.maxWidth = maxWidth;
    config.maxHeight = maxHeight;

    return config;
  }
}
